<template>
    <v-container>
        <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-card>
                <v-card-text>
                  <ol>
                    <li>Open your mobile chrome browser and type http://meherbabaapp.com/ </li>
                    <li>Follow the below steps to install Mobile App.</li>
                  </ol>
                </v-card-text>
              </v-card>
              <v-card align="center">
                <img align="center" src="/static/doc-images/Instructions/ambppct final.gif" alt="This is an animated gif image, but it does not move"/>
              </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
  export default {
    data () {
      return {
        items: [
          {
            src: '/static/doc-images/Instructions/Picture1.jpg'
          },
          {
            src: '/static/doc-images/Instructions/Picture2.jpg'
          },
          {
            src: '/static/doc-images/Instructions/Picture3.jpg'
          }
        ]
      }
    },
    created: function () {
      if ((window.matchMedia('(display-mode: standalone)').matches)) {
        this.$router.push('/Home')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// instructions.vue?691ef344